<template>

  <v-container
    v-if="room && slugs &&rates && standards && facilities"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    fluid
  >

    <v-card outlined class="ma-2" style="margin-bottom: 58px !important;">
      <v-card-title v-once>
        {{room.name || 'Create'}}
      </v-card-title>
      <v-divider class="mx-4"/>
      <v-card-text>

        <v-row no-gutters>
          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Detalii</div>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="room.name" label="Nume" class="ma-1" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-select v-model="room.standard" label="Standard" class="ma-1" :items="standards" item-text="name" item-value="id" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-select v-model="room.slug" label="Identificator" class="ma-1" :items="slugs[room.standard]" item-text="name" item-value="id" :disabled="!room.standard" outlined dense hide-details/>
          </v-col>
          <v-col cols="12">
            <v-select v-model="room.status" class="ma-1" :items="[{id: 'active', name: 'Activat'}, {id: 'inactive', name: 'Dezactivat'}]" item-text="name" item-value="id" label="Status" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="room.static.occupancy.adults" class="ma-1" label="Ocupanta" type="number" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="room.static.extrabeds" class="ma-1" label="Paturi suplimentare" type="number" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-select v-model="room.static.single_stay" class="ma-1" :items="[{id: true, name: 'Da'}, {id: false, name: 'Nu'}]" item-text="name" item-value="id" label="Single Stay" outlined dense hide-details/>
          </v-col>
          <v-col cols="6">
            <v-select v-model="room.static.small_child_in_bed" class="ma-1" :items="[{id: true, name: 'Da'}, {id: false, name: 'Nu'}]" item-text="name" item-value="id" label="Pat gratis pt. copii" outlined dense hide-details/>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Planuri Tarifare</div>
          </v-col>
          <v-col cols="12">
            <v-item-group v-model="room.rate_plan_ids" multiple>
              <v-item v-for="rate in rates.data" :key="rate.id" :value="rate.id" v-slot:default="{ active, toggle }">
                <v-btn depressed :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{rate.name}}<sub><small>ID:({{rate.id}})</small></sub></v-btn>
              </v-item>
            </v-item-group>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Facilități</div>
          </v-col>
          <v-col cols="12">
            <v-autocomplete v-model="room.static.facilities" :items="facilities" item-value="id" item-text="name" class="ma-1" label="Facilități" multiple outlined dense hide-details>
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected" @click:close="removeFacility(data.item)" close small>
                  {{data.item.name}}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-black ma-1">Galerie</div>
          </v-col>
          <v-col cols="12">
            <v-file-input v-model="images" accept="image/*" class="ma-1" label="Adaugă poze" @change="onImageChange($event)" multiple small-chips show-size outlined dense hide-details/>
          </v-col>
          <v-col
            v-for="(image, index) in room.images"
            :key="`image_${index}`"
            class="d-flex child-flex"
            cols="2"
          >

            <v-hover v-slot:default="{ hover }">
              <v-img :src="image.url" aspect-ratio="1" class="grey lighten-2 d-flex ma-1">
                <v-row class="fill-height" align="center" justify="center">
                  <v-fade-transition>
                    <v-card v-if="hover" style="height: 100%; width: 100%; background-color: rgba(255,255,255,.8)">
                      <v-row align="center" justify="center" class="fill-height">
                        <v-btn fab depressed color="delete white--text" :loading="deleting_image" @click="removeImage(image)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-row>
                    </v-card>
                  </v-fade-transition>
                </v-row>
              </v-img>
            </v-hover>

          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <v-card outlined v-resize="onResize" :width="dynamic_width" class="ma-2" :style="{position: 'fixed', bottom: 0, maxWidth: '960px'}">
      <v-card-actions>
        <v-btn v-if="$route.params.room!=='create'" depressed color="delete white--text" @click="destroy" :loading="deleting" :disabled="deleting">
          <v-icon left>mdi-delete</v-icon>
          Șterge
        </v-btn>
        <v-spacer/>
        <v-btn depressed color="primary white--text" @click="save" :loading="saving" :disabled="saving">
          <v-icon left>mdi-floppy</v-icon>
          Salvează
        </v-btn>
      </v-card-actions>
    </v-card>


  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import room_repository from '@/repositories/room-repository'
  import media_repository from '@/repositories/media-repository'
  import rate_repository from '@/repositories/rate-repository'
  import config_repository from '@/repositories/config-repository'

  export default {
    data: () => ({
      room: null,

      rates: null,
      slugs: null,
      standards: null,
      facilities: null,
      images: null,
      images_64: null,

      saving: false,
      deleting: false,
      deleting_image: false,

      dynamic_width: 0
    }),

    async created() {
      room_repository.getRoom(this.$route.params.hotel, this.$route.params.room).then(r => this.room = r);
      rate_repository.getRates(this.$route.params.hotel, {size: Number.MAX_SAFE_INTEGER , page: 1}).then(r => this.rates = r );
      config_repository.getRoomSlugs().then(r => this.slugs = r);
      config_repository.getRoomStandards().then(r => this.standards = r);
      config_repository.getRoomFacilities().then(r => this.facilities = r);
    },

    methods: {

      async save() {
        try {
          this.saving = true;
          this.room = await room_repository.saveRoom(this.$route.params.hotel, this.room);
          await media_repository.saveMedia(this.room.id, 'room-types', {images: this.images_64});
          await this.$store.dispatch('alert/success', 'Success');
          this.$route.params.room === 'create'
            ? await this.$router.push(`/hotels/${this.$route.params.hotel}/rooms/${this.room.id}`)
            : this.room = await room_repository.getRoom(this.$route.params.hotel, this.room.id);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.saving = false;
          this.images = null;
          this.images_64 = null;
        }
      },

      async destroy() {
        try {
          this.deleting = true;
          await room_repository.destroyRoom(this.$route.params.hotel, this.room.id);
          await this.$router.push(`/hotels/${this.$route.params.hotel}/rooms`);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting = false;
        }
      },

      removeFacility(facility) {
        const index = this.room.static.facilities.indexOf(facility.id);
        if (index >= 0) this.room.static.facilities.splice(index, 1)
      },

      async removeImage(image) {
        try {
          this.deleting_image = true;
          await media_repository.deleteMedia(this.$route.params.room,'room-types', image);
          this.room = await room_repository.getRoom(this.$route.params.hotel, this.room.id);
        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.deleting_image = false;
        }
      },

      onImageChange(files) {
        this.images_64 = [];
        for (let file of files) {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            this.images_64.push({data: fileReader.result});
          });
          fileReader.readAsDataURL(file);
        }
      },

      onResize() {
        this.dynamic_width = this.$refs['parent'].clientWidth - 40;
      }

    }
  }
</script>